module.exports = __webpack_public_path__ + "img/weed_pack.2999ecb7.png";